import {memo, shapeComponent, ShapeComponent, Text, View} from "shared/base"
import AdminButton from "components/admin/button"
import AdminInput from "components/admin/input"
import AdminLayout from "components/admin/layout"
import AppHistory from "shared/history"
import Contact from "models/contact.js"
import Link from "@kaspernj/api-maker/build/link"
import Nav from "./nav"
import React from "react"
import Routes from "shared/routes"
import setLayout from "shared/set-layout"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import useModel from "@kaspernj/api-maker/build/use-model"
import UtilsCard from "components/utils/card"
import {Form} from "@kaspernj/api-maker/build/form" // eslint-disable-line sort-imports
import {FlashNotifications as FlashMessage} from "flash-notifications" // eslint-disable-line sort-imports

export default memo(shapeComponent(class RoutesAdminContactsMapStripeSubscription extends ShapeComponent {
  setup() {
    setLayout("admin")

    const {t} = useI18n({namespace: "js.routes.admin.contacts.map_stripe_subscription"})
    const formRef = React.useRef()
    const {contact, contactId} = useModel(Contact, {
      match: this.p.match,
      preload: ["school", "school_class.school", "user"],
      select: {
        Contact: ["contactPointsCount", "id", "name"],
        School: ["id", "name"],
        SchoolClass: ["id", "interpretedName"],
        User: ["id", "name"]
      }
    })

    this.setInstance({contact, contactId, formRef, t})
  }

  render() {
    const {contact, t} = this.tt

    return (
      <AdminLayout
        active="contacts"
        headerTitle={contact?.name()}
      >
        {contact &&
          <View testID="admin-contact-map-stripe-subscription-route">
            <Nav active="general" contact={contact} style={this.navStyle ||= {marginBottom: 15}} />
            <View testID="admin-contact-map-stripe-subscription-card">
              <UtilsCard style={this.cardStyle ||= {maxWidth: 700}}>
                <Text testID="admin-contact-map-stripe-subscription-introduction-text">
                  {t(".introduction")}
                </Text>
                <View
                  style={this.formContainerStyle ||= {marginTop: 20}}
                  testID="admin-contact-map-stripe-subscription-form-container"
                >
                  <Form formObjectRef={this.tt.formRef} onSubmit={this.tt.onSubmit}>
                    <AdminInput
                      label={t(".stripe_subscription_id")}
                      name="stripe_subscription_id"
                      style={this.inputStyle ||= {marginBottom: 15}}
                      testID="admin-contact-map-stripe-subscription-id-input"
                    />
                    <View
                      style={this.actionsStyle ||= {flexDirection: "row", gap: 10}}
                      testID="admin-contact-map-stripe-subscription-actions"
                    >
                      <AdminButton
                        icon="check"
                        primary
                        submit
                        testID="admin-contact-map-stripe-subscription-submit-button"
                        title={t(".map_subscription")}
                      />
                      <Link
                        testID="admin-contact-map-stripe-subscription-back-link"
                        to={Routes.adminContactPath(contact.id())}
                      >
                        <Text>
                          {t(".back_to_contact")}
                        </Text>
                      </Link>
                    </View>
                  </Form>
                </View>
              </UtilsCard>
            </View>
          </View>
        }
      </AdminLayout>
    )
  }

  onSubmit = async () => {
    const {contact, formRef, t} = this.tt
    const stripeSubscriptionId = formRef.current?.getValue("stripe_subscription_id")?.trim()

    if (!stripeSubscriptionId) {
      FlashMessage.alert(t(".please_enter_a_stripe_subscription_id"))

      return
    }

    try {
      await contact.mapStripeSubscription({stripe_subscription_id: stripeSubscriptionId})
      FlashMessage.success(t(".the_stripe_subscription_was_mapped"))
      AppHistory.push(Routes.adminContactPath(contact.id()))
    } catch (error) {
      FlashMessage.errorResponse(error)
    }
  }
}))
